import { hasCompanyManagementRole } from '@/constants/roleTypes';
export function canViewUserManual() {
  try {
    return hasCompanyManagementRole(JSON.parse(sessionStorage.getItem('roleList') || '[]'));
  } catch (error) { return false; }
}
